import Loadable from 'react-loadable';

export default Loadable({
  loader: () => import(/* webpackChunkName: "QuestionMeta" */ './QuestionMeta'),
  loading: () => null,
});
